import { render } from "./share-link.vue?vue&type=template&id=71b3948a"
import script from "./share-link.vue?vue&type=script&lang=js"
export * from "./share-link.vue?vue&type=script&lang=js"

import "./share-link.vue?vue&type=style&index=0&id=71b3948a&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-team/double-column-simple/share-link.vue'],['render',render],['__file',"share-link.vue"]])

export default __exports__